module.exports = __webpack_public_path__ + "static/media/cedric-poster.fca0a855.png";